import { HomePageProps } from './HomePage.types'
import { PageWrapper } from "@otomoro/components/layout/PageWrapper"
import { HeroMedia } from "@otomoro/components/shared/HeroMedia"
import { HomeFlexibleContent } from "@otomoro/components/home/HomeFlexibleContent"
import { VideoHero } from "@otomoro/components/home/videoHero/VideoHero"

export default function HomePage({ data }: HomePageProps) {

	if (!data) {
		return (
			<div className="text-center">Please start editing your Home document to see the preview!</div>
		)
	}

	const blocks = data.flexibleContent as any
	const lastType = blocks[blocks.length - 1]._type as string

	return (
		<PageWrapper noPb={lastType === 'alternateSection'}>
			<HeroMedia media={data.heroImage} headline="different by nature" />
			<VideoHero
				videoUrl="https://player.vimeo.com/video/1064634313?h=38ee7664a5&title=0&byline=0&portrait=0"
				title={{
					_type: 'block',
					_key: 'title',
					children: [
						{
							_type: 'span',
							_key: 'title-span-1',
							text: 'WE NEED TO '
						},
						{
							_type: 'span',
							_key: 'title-span-2',
							text: 'RE:IMAGINE',
							marks: ['pink']
						}
					],
				}}
				description={{
					_type: 'block',
					_key: 'description',
					children: [
						{
							_type: 'span',
							_key: 'description-span',
							text: 'For hundreds of years humanity has been using fossil-fuel chemicals to make plastics, cosmetics, detergents. Everything we touch every day.'
						}
					],
				}}
			/>
			<HomeFlexibleContent blocks={data.flexibleContent as any} />
		</PageWrapper>
	)
}
